// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"box_wrapper__3eJmX","body":"box_body__2AyIP","head":"box_head__2HF05","headwrapper":"box_headwrapper__1y0bl","title":"box_title__AXrh-","extra":"box_extra__3B-34"};